export default {"src":"/_next/static/image/public/images/flags/flag_226.d93f6564da17b16f03eff20a3722cedf.svg","height":16,"width":24};